import { useState, useEffect } from 'react';
import { useGetEULAV1Query, useUpdateUserAcceptedEULAV1Mutation } from '../store/penpalServerAPI';
import EULAViewer from '../components/dashboard/utils/EULAViewer';
import { useSetUser } from '../auth/UserContext';
import { useAuth0 } from '@auth0/auth0-react';

const AcceptEULA = ({ user }) => {
    const [pdfURL, setPdfURL] = useState(null);
    const [agreed, setAgreed] = useState(false);
    const updateUser = useSetUser();
    const { data, isLoading, isSuccess } = useGetEULAV1Query();
    const [updateAcceptedUser, { isLoading: isUpdating }] = useUpdateUserAcceptedEULAV1Mutation();
    const { logout } = useAuth0();

    function base64ToUint8Array(base64) {
        const binaryString = atob(base64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes;
    }

    useEffect(() => {
        if (isSuccess && data?.content) {
            const byteArray = base64ToUint8Array(data.content);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            setPdfURL(url);
            return () => URL.revokeObjectURL(url);
        }
    }, [data, isSuccess]);

    function handleAgree() {
        setAgreed(true);
    }

    const handleContinue = async () => {
        try {
            await updateAcceptedUser(user.UserID).unwrap();
            updateUser({
                ...user,
                AcceptedEULA: true
            });
        } catch (err) {
            console.error("Failed to update acceptedEULA:", err);
        }
    };

    const handleLogout = async () => {
        logout({ logoutParams: { returnTo: window.location.origin } });
    };

    
    return (
        <div className="relative h-full w-full">
            <EULAViewer pdfUrl={pdfURL} onAgree={handleAgree} />
            <button
                onClick={handleContinue}
                disabled={!agreed || isUpdating}
                className={`fixed bottom-4 right-4 px-6 py-2 rounded-lg shadow-md transition-colors duration-300 
                    ${agreed && !isUpdating
                        ? 'bg-green-600 hover:bg-green-700 text-white cursor-pointer'
                        : 'bg-gray-400 text-white cursor-not-allowed'}`}
            >
                {isUpdating ? 'Processing...' : 'Continue'}
            </button>
            <button     // Nothing too special, I just hate having to go into the database to change the EULA accept bool if im on the wrong account. -MM
                className="fixed bottom-4 left-4 px-6 py-2 rounded-lg shadow-md bg-red-500 text-center font-semibold text-white"
                onClick={handleLogout}
              >
                Logout
              </button>
        </div>
    );
};

export default AcceptEULA;
